import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { videoProgress, completeVideo } from '../redux/actions';

import { selectActiveLibraryRecord, selectActiveCategory, selectFavoritesAsCategory } from './redux/selectors';

import VideoPlayer from '../../common/video/VideoPlayer';

class LibraryVideo extends Component {
  static propTypes = {
    activeLibraryRecord: PropTypes.object,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  };

  handleProgress = currentTime => {
    this.props.dispatch(videoProgress(this.props.activeLibraryRecord.getIn(['video', 'id']), currentTime));
  };

  handleEnd = () => {
    const { activeLibraryRecord, match, history } = this.props;

    const video = activeLibraryRecord.get('video');

    this.handleProgress(video.get('duration'));
    this.props.dispatch(completeVideo(video.get('id')));

    history.push(`/subscription/library/${match.params.categoryId}`);
  };

  render() {
    const { activeLibraryRecord, match, activeCategory } = this.props;

    if (match.params.categoryId !== 'favorites' && !activeLibraryRecord.get('user_eligible')) {
      return <div>To view this video you must complete its respective lesson in the course.</div>;
    }

    return (
      <div className="fullscreen__video-player__wrapper">
        <VideoPlayer
          autoplay={true}
          title={activeLibraryRecord.get('name')}
          poster={activeLibraryRecord.getIn(['image', 'location'])}
          onProgress={this.handleProgress}
          onEnd={this.handleEnd}
          backText={`Back to ${activeCategory.get('name')}`}
          backTo={`/subscription/library/${match.params.categoryId}`}
          video={activeLibraryRecord.get('video')}
          sendToIntercom
          intercomEventName={'watched_libvideo'}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const categories = state.subscription.library.categories;
  const favorites = state.subscription.favorites.favorites;
  const categoryId = props.match.params.categoryId;
  const activeCategory =
    categoryId === 'favorites'
      ? selectFavoritesAsCategory(favorites)
      : selectActiveCategory(categories, props.match.params.categoryId);

  return {
    activeCategory,
    activeLibraryRecord: selectActiveLibraryRecord(activeCategory, props.match.params.videoId),
  };
};

export default connect(mapStateToProps)(LibraryVideo);



// WEBPACK FOOTER //
// ./src/subscription/library/LibraryVideo.js